export default {
      id: "icon--clock-clockwise-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--clock-clockwise-usage",
      toString: function () {
        return this.url;
      }
    }